function getServiceWorker() {
  if (import.meta.server) return null
  if (!("serviceWorker" in navigator)) return null
  return navigator.serviceWorker
}

export function listenForServiceWorkerMessages() {
  // Listen for messages from the service worker
  getServiceWorker()?.addEventListener("message", event => {
    if (event.data.cache.type === "UPDATED") {
      console.info(
        "The following cache entry has been updated",
        event.data.cache,
      )
      console.info(
        "Reloading the page to get the latest version of the cache",
      )
      //location.reload()
    }
  })
}

export function sendMessageToSW(message: PWA.MessageToSW): void {
  getServiceWorker()?.ready.then(registration => {
    registration.active?.postMessage(message)
  })
}
